import { render, staticRenderFns } from "./WaiverTemplate.vue?vue&type=template&id=0aaf2151&scoped=true"
import script from "./WaiverTemplate.vue?vue&type=script&lang=js"
export * from "./WaiverTemplate.vue?vue&type=script&lang=js"
import style0 from "./WaiverTemplate.vue?vue&type=style&index=0&id=0aaf2151&prod&scoped=true&lang=css"
import style1 from "./WaiverTemplate.vue?vue&type=style&index=1&id=0aaf2151&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf2151",
  null
  
)

export default component.exports